import React, { Fragment, useEffect } from 'react'
import PropTypes from 'prop-types';

/* COMPONENTS */
import Header from '../Header/header'
import Footer from '../../components/Footer/footer'
import '../../font/font.css'

/* MAIN SCSS */
import '../../scss/base.scss'

const Layout = ({ children }) => {
  // Disparar conversão do Google Ads ao carregar qualquer página
  useEffect(() => {
    // Aguardar um pouco para garantir que o gtag esteja carregado
    const timer = setTimeout(() => {
      if (typeof window !== 'undefined' && window.trackConversion) {
        window.trackConversion();
        console.log('Conversão do Google Ads disparada automaticamente');
      }
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <Fragment >
      <Header/>
      <main>
        { children }
      </main>
      <Footer />
    </Fragment>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout
